import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import { RegisterForm } from "./RegisterForm";
import { JandiSymbol } from "@/components/assets/logos/svgs";

const Register = () => {
  return (
    <div className="form-inner">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <JandiSymbol style={{ marginTop: 20, height: 60, width: 60 }} alt />
      </div>
      <h3 style={{ color: "white", fontWeight: 600 }}>Jandi - Profesionales</h3>

      <Tabs>
        <div className="form-group register-dual">
          <TabList className="btn-box row">
            <Tab className="col-lg-6 col-md-12">
              <button
                style={{ borderRadius: 0 }}
                className="theme-btn btn-style-four"
              >
                <i className="la la-user"></i> Contratar
              </button>
            </Tab>

            <Tab className="col-lg-6 col-md-12">
              <button
                style={{ borderRadius: 0 }}
                className="theme-btn btn-style-four"
              >
                <i className="la la-briefcase"></i> Ofrecer Servicios
              </button>
            </Tab>
          </TabList>
        </div>

        <TabPanel>
          <RegisterForm isWorker={false} />
        </TabPanel>

        <TabPanel>
          <RegisterForm isWorker />
        </TabPanel>
      </Tabs>

      <div className="bottom-box">
        <div className="text" style={{ color: "white" }}>
          ¿Ya tienes una cuenta?{" "}
          <Link
            to="#"
            className="call-modal login"
            data-bs-toggle="modal"
            data-bs-dismiss="modal"
            data-bs-target="#loginPopupModal"
            style={{ color: "white" }}
          >
            Ingresar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
